<div class="reports-container">
  <risr-header-card>
    <h1 risrHeaderCardTitle i18n="Reports|Title">Reports</h1>
  </risr-header-card>

  <div class="reports-list">
    <risr-list-view>
        <ng-template #itemTemplate let-item>
          <risr-slot-card [title]="item.name" [link]="['./run', item.id]">
            <div risrSlotCardTitle>
              @if (item.type === 'report') {
                <a class="slot-card__title" [routerLink]="['./run', item.id]">{{ item.name }}</a>
              }
              @if (item.type === 'reportTemplate') {
                <a class="slot-card__title" [routerLink]="['../report_templates/run', item.id]">{{ item.name }}</a>
              }
            </div>
            <div risrSlotCardActions>
              @if (item.type === 'report') {
                <a mat-stroked-button [routerLink]="['./run', item.id]" color="primary">
                  <span i18n>Run</span>
                </a>
              }
              @if (item.type === 'reportTemplate') {
                <a mat-stroked-button [routerLink]="['../report_templates/run', item.id]" color="primary">
                  <span i18n>Run</span>
                </a>
              }
            </div>
          </risr-slot-card>
        </ng-template>
    </risr-list-view>
  </div>
</div>
